import FavouriteBooksBlankSlate from "./FavouriteBooksBlankSlate";

export default FavouriteBooksBlankSlate;
